import React from 'react';

export type FixtureRow = {
  /** Shown left, e.g. "Sun 14 Jun" */
  dateLabel: string;
  /** e.g. "Group A", "Round of 16" */
  stage?: string;
  homeTeam: string;
  awayTeam: string;
  venue?: string;
  /** Local kick-off label */
  time?: string;
  /** When known, e.g. "2–1" */
  score?: string;
};

type FixturesTableProps = {
  fixtures: FixtureRow[];
  caption?: string;
};

function FixturesTable({ fixtures, caption }: FixturesTableProps) {
  return (
    <div className="wc26-table-scroll">
      <table className="wc26-table wc26-fixtures-table">
        {caption ? <caption>{caption}</caption> : null}
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Stage</th>
            <th scope="col">Match</th>
            <th scope="col">Venue</th>
            <th scope="col">Time</th>
            <th scope="col">Score</th>
          </tr>
        </thead>
        <tbody>
          {fixtures.map((row, i) => (
            <tr key={`${row.dateLabel}-${row.homeTeam}-${row.awayTeam}-${i}`}>
              <td>{row.dateLabel}</td>
              <td>{row.stage ?? '—'}</td>
              <td>
                <span className="wc26-fixture-teams">
                  <span className="wc26-team-home">{row.homeTeam}</span>
                  <span className="wc26-vs" aria-hidden>
                    v
                  </span>
                  <span className="wc26-team-away">{row.awayTeam}</span>
                </span>
              </td>
              <td>{row.venue ?? '—'}</td>
              <td>{row.time ?? 'TBC'}</td>
              <td>{row.score ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default FixturesTable;
